import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const LoadingAnalysis = () => {
  return (
    <Box sx={{ textAlign: 'center', py: 4 }}>
      <CircularProgress size={60} sx={{ mb: 2 }} />
      <Typography variant="h6" gutterBottom>
        🤖 Analyzing Furniture Image...
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        • Identifying furniture type and brand
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        • Searching product databases online
      </Typography>
      <Typography variant="body2" color="text.secondary">
        • Fetching pricing and specifications
      </Typography>
    </Box>
  );
};

export default LoadingAnalysis;
